import {memo} from 'react';
import styled from 'styled-components';
import {Palette} from 'hubbl-shared';
import {UserInfoDisplay} from '../user-info/UserInfoDisplay';
import {PaddingRight} from '../padding/PaddingRight';
import {AdminViewToggle} from '../admin-view-toggle/AdminViewToggle';

export const Topbar = memo(() => {
  return (
    <StyledTopbar>
      <AdminViewToggle />
      <UserInfoDisplay />
      <PaddingRight amount={24} />
    </StyledTopbar>
  );
});

const StyledTopbar = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0 24px;
  background-color: ${Palette.whiteTransparent60};
  height: 60px;
  min-height: 60px;
  flex-shrink: 0;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0px 2.858px 17.148px 0px rgba(0, 0, 0, 0.08);
  transition: box-shadow 0.3s ease-in-out;
`;
